module.exports = __webpack_public_path__ + "img/logo.068eb4ef.png";